module.exports = __webpack_public_path__ + "static/media/Picture13.08e1c052.jpg";